import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { useTenant } from '../../hooks/useTenant';
import type { TimeRange } from '../types';
import { requireTenant } from './queryGuards';

interface UseNamespacesParams {
  time_range?: TimeRange;
}

export function useNamespaces(params: UseNamespacesParams = {}) {
  const { tenantId } = useTenant();
  const timeRange =
    params.time_range === 'custom' ? '7d' : params.time_range ?? '24h';

  return useQuery({
    queryKey: ['namespaces', tenantId, timeRange],
    queryFn: () => {
      const requiredTenantId = requireTenant(tenantId);
      return apiClient.getNamespaces({
        tenant_id: requiredTenantId,
        time_range: timeRange,
      });
    },
    enabled: !!tenantId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
